<app-side-top-bar [navigationItems]="navigationItems">
  <main class="ai-analysis-page">
    <mat-card class="ai-analysis-card">
      <mat-card-content class="content-wrapper">
        <div class="title-container">
          <h2 class="page-title">Analisi AI</h2>
        </div>
        <app-ai-disclaimer variant="trigger"></app-ai-disclaimer>

        <section class="analysis-content">
          @if (isLoading) {
            <div class="loading-container">
              <app-loader [size]="'big'"></app-loader>
            </div>
          }
          @if (!isLoading) {
            <div class="patient-list-container">
              <app-custom-search-bar
                style="height: 35px"
                [placeholder]="'Cerca paziente'"
                (search)="filterPatients($event)"
              >
              </app-custom-search-bar>
              @if (patients.length > 0) {
                <table
                  mat-table
                  [dataSource]="patientListDataSource"
                  class="patient-table mat-elevation-z2"
                >
                  <ng-container matColumnDef="name">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="font-weight: bold"
                    >
                      Paziente
                    </th>
                    <td mat-cell *matCellDef="let patient">
                      <div class="patient-list-item">
                        <span
                          >{{ patient.first_name }}
                          {{ patient.last_name }}</span
                        >
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="navigateToPatientAnalysis(patient)"
                        >
                          Mostra Analisi
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              }
              @if (patients.length === 0) {
                <div class="no-patients-container">
                  <img src="assets/imgs/undraw/undraw_development.svg" />
                  <span>Nessun paziente trovato.</span>
                </div>
              }
            </div>
          }

          @if (!isMobile) {
            <aside class="ai-features-description">
              <header class="features-intro">
                <h3 class="features-intro__title">
                  Benvenuto nella Dashboard AI
                </h3>
                <p class="features-intro__subtitle"></p>
                <!-- empty content. we might add content later. -->
              </header>

              @for (group of aiFeatureGroups; track group.id) {
                <section class="feature-group">
                  <h4 class="feature-group__title">{{ group.title }}</h4>
                  <div class="feature-grid">
                    @for (feature of group.features; track feature.id) {
                      <button
                        type="button"
                        class="feature-item"
                        [class.selected]="selectedFeature === feature.id"
                        [attr.aria-pressed]="selectedFeature === feature.id"
                        (click)="toggleFeatureDescription(feature.id)"
                        (mouseenter)="selectedFeature = feature.id"
                        (focus)="selectedFeature = feature.id"
                      >
                        <mat-icon>{{ feature.icon }}</mat-icon>
                        <span>{{ feature.label }}</span>
                      </button>
                    }
                  </div>
                </section>
              }

              <div class="feature-detail" aria-live="polite">
                @if (activeFeature) {
                  <p class="feature-detail__text" [@fadeInOut]="'in'">
                    <strong>{{ activeFeature.label }}</strong>
                    {{ activeFeature.description }}
                  </p>
                } @else {
                  <p class="feature-detail__hint" [@fadeInOut]="'in'">
                    Seleziona una funzionalità per leggerne la descrizione.
                  </p>
                }
              </div>
            </aside>
          }
        </section>
      </mat-card-content>
    </mat-card>
  </main>
</app-side-top-bar>
